import DataGrid, { Column, Item, Toolbar, SearchPanel, Paging, Pager } from 'devextreme-react/data-grid';
import './Cashier.scss';
import DataSource from 'devextreme/data/data_source';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import CustomStore from 'devextreme/data/custom_store';
import { CashierFilter } from '../../../types/types.orders';
import moment from 'moment';
import { FormPopup, newToast, ModalConfirmation } from '../../../components';
import Form, { Item as ItemF } from 'devextreme-react/form';
import { useApiOrders } from '../../../api/api.orders';
import { formatNumber } from 'devextreme/localization';
import { useApiConfiguration } from '../../../api/api.configuration';
import Popup, { ToolbarItem } from 'devextreme-react/popup';
import { useScreenSize } from '../../../utils/media-query';
import { Button, NumberBox, SelectBox, TextArea, Tooltip } from 'devextreme-react';
import { CreateOrders, filter, LiquidatedIcon, NotLiquidatedIcon, resButtonRefresh } from '../../../images/icons';
import ModalCreatePreOrder from '../../Preorders/Modals/ModalCreatePreOrder';
import { useAppSelector } from '../../../contexts/hooks';
import { useApiBilling } from '../../../api/api.billing';
import { TypeCombobox } from '../../../types/types.config';

const currentFilters: CashierFilter = {
  Fechas: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
  PacDocument: '',
  Ordenes: [null, null],
  Usuarios: [],
  Servicios: [],
  Contratos: [],
  Estado: null,
};

const Index = () => {
  const gridRef = useRef<DataGrid>(null);
  const [dataSource, setDataSource] = useState([]);
  const { isXSmall } = useScreenSize();
  const { GetCashierOrder, CreateCashierOrder } = useApiOrders();
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const { getPaymentMethods } = useApiConfiguration();
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [modalFiltersVisible, setModalFiltersVisible] = useState(false);
  const [modalLiquidarVisible, setModalLiquidarVisible] = useState(false);
  const [modalConfirmZeroValues, setModalConfirmZeroValues] = useState(false);
  const [loading, setLoading] = useState(false);
  const { getSimpleUsuarios } = useApiBilling();
  const [currentIdPreOrder, setCurrentIdPreOrder] = useState(-1);
  const [modalPreOrderVisible, setModalPreOrderVisible] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const Prm_FactCajaLiquidar = useAppSelector((state) => state.userInfo.Permissions?.Prm_FactCajaLiquidar);
  const Prm_FactCaja_U = useAppSelector((state) => state.userInfo.Permissions?.Prm_FactCaja_U);
  const Prm_Preordenes = useAppSelector((state) => state.userInfo.Permissions?.Prm_Preordenes);
  const lstServicios = useAppSelector((state) => state.configuration.Data?.ComboBox.filter((x) => x.Name === 'SysA_Servicios')[0]?.Data || []);
  const allCombobox = useAppSelector((state) => state.configuration.Data?.ComboBox || []);
  const contratoField = useAppSelector((x) => x.configuration.Data?.DefinicionesCampos.filter((x) => x.Dfc_Equivalencia === 'Ord_Cn_Id')[0] || null);
  const [lstContratos, setLstContratos] = useState<TypeCombobox>();
  // Define a type for payment items
  type PaymentItem = {
    Rof_Id?: number | null;
    Rof_Fecha?: Date | null;
    Rof_Fp_Id: string | null;
    Rof_Valor: number | null;
    Rof_Nota?: string | null;
  };

  // Update the state to use the defined type
  const [paymentItems, setPaymentItems] = useState<PaymentItem[]>([]);

  const customDataSrc = useMemo(() => {
    return new CustomStore({
      key: 'Ord_Id',
      load: () =>
        Promise.resolve({
          data: dataSource,
          totalCount: dataSource.length || 0,
        }),
    });
  }, [dataSource]);

  const customData = useMemo(() => {
    return new DataSource({
      store: customDataSrc,
      reshapeOnPush: true,
    });
  }, [customDataSrc]);

  useEffect(() => {
    getPaymentMethods().then(setPaymentMethods);
    getSimpleUsuarios().then(setUsersList);
    var currentCmb = allCombobox.filter((x) => x.Id === contratoField?.Dfc_Tbc_Id)[0];
    setLstContratos(currentCmb);
  }, []);

  const handleModalShowFilter = useCallback(() => {
    setModalFiltersVisible(!modalFiltersVisible);
  }, [modalFiltersVisible]);

  const fetchData = useCallback(async () => {
    gridRef.current?.instance?.beginCustomLoading('');
    const result = await GetCashierOrder(currentFilters);
    setDataSource(result);
    gridRef.current?.instance?.endCustomLoading();
  }, []);

  const handleUpdateData = useCallback(() => {
    setModalFiltersVisible(false);
    fetchData();
  }, [setModalFiltersVisible, fetchData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleClickLiquidar = useCallback(async (data) => {
    setSelectedRow(data);

    const abonosPrevios = data.OrdenesFacturacionFormasPago || [];
    const nuevos = !data.Ord_Liquidado ? [{ Rof_Fp_Id: null, Rof_Valor: null }] : [];

    setPaymentItems([...abonosPrevios, ...nuevos]);
    setModalLiquidarVisible(true);
  }, []);

  const onCancelClickLiquidar = useCallback(() => {
    setModalLiquidarVisible(false);
  }, [setModalLiquidarVisible]);

  const handleAddPaymentItem = () => {
    setPaymentItems([...paymentItems, { Rof_Fp_Id: null, Rof_Valor: null, Rof_Nota: null }]);
  };

  const handlePaymentItemChange = (index: number, field: keyof PaymentItem, value: any) => {
    const updatedItems = [...paymentItems];
    updatedItems[index][field] = value;
    setPaymentItems(updatedItems);
  };

  const handleConfirmLiquidar = useCallback(() => {
    if (!Prm_FactCajaLiquidar && !Prm_FactCaja_U) {
      newToast('WARNING', 'No tiene permisos para liquidar o editar la caja.', 5);
      return;
    }

    // Validar que todos los abonos tengan forma de pago
    const isValid = paymentItems.every((item) => item.Rof_Fp_Id);
    if (!isValid) {
      newToast('WARNING', 'Todos los abonos deben tener forma de pago.', 5);
      return;
    }

    // Verificar si hay valores en 0 (incluyendo null/undefined que se convertirán a 0)
    const hasZeroValues = paymentItems.some((item) => (item.Rof_Valor ?? 0) === 0);
    if (hasZeroValues) {
      setModalConfirmZeroValues(true);
      return;
    }

    proceedWithLiquidation();
  }, [paymentItems, selectedRow, Prm_FactCaja_U, Prm_FactCajaLiquidar]);

  const proceedWithLiquidation = useCallback(() => {
    // Siempre enviar todos los abonos, incluyendo los que ya existen (con su Rof_Id)
    const abonosAGuardar = paymentItems.map((item) => ({
      ...item,
      Rof_Ord_Id: selectedRow.Ord_Id,
      // Convertir null/undefined a 0
      Rof_Valor: item.Rof_Valor ?? 0,
    }));

    setLoading(true);
    CreateCashierOrder(abonosAGuardar)
      .then(() => {
        setModalLiquidarVisible(false);
        fetchData();
        setPaymentItems([]);
        setSelectedRow(null);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [paymentItems, selectedRow]);

  const handleConfirmZeroValues = useCallback(() => {
    setModalConfirmZeroValues(false);
    proceedWithLiquidation();
  }, [proceedWithLiquidation]);

  const handleCancelZeroValues = useCallback(() => {
    setModalConfirmZeroValues(false);
  }, []);

  const handleFindPreOrder = useCallback(
    (idPreorden) => {
      setCurrentIdPreOrder(idPreorden);
      setModalPreOrderVisible(true);
    },
    [setCurrentIdPreOrder, setModalPreOrderVisible]
  );

  const handleClosePreOrder = useCallback(() => {
    setModalPreOrderVisible(false);
  }, [setModalPreOrderVisible]);

  const renderEstadoLiquidacion = ({ data }: any) => {
    const estado = data.Ord_Liquidado;
    const id = `estado-icon-${data.Ord_Id}`;
    const icon = estado ? LiquidatedIcon : NotLiquidatedIcon;
    const altText = estado ? 'Liquidado' : 'No liquidado';

    return (
      <div
        id={id}
        style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center' }}
        onClick={() => {
          handleClickLiquidar(data);
        }}>
        <img src={icon} alt={altText} style={{ width: 20, height: 20 }} />
        <Tooltip target={`#${id}`} showEvent='mouseenter' hideEvent='mouseleave' position='top'>
          {altText}
        </Tooltip>
      </div>
    );
  };

  return (
    <div className={'view crm-contact-list'}>
      <div className={'view-wrapper view-wrapper-contact-list'}>
        <DataGrid className='grid' allowColumnReordering allowColumnResizing dataSource={customData} ref={gridRef} hoverStateEnabled={true} height='100%' width={'100%'} repaintChangesOnly={false} highlightChanges={false} rowAlternationEnabled={true} showColumnLines={true}>
          <SearchPanel visible={true} />
          <Paging enabled={true} />
          <Pager visible={true} allowedPageSizes={[20, 50, 100, 'all']} displayMode='full' showPageSizeSelector={true} showInfo={true} showNavigationButtons={true} />
          <Toolbar>
            <Item location='before'>
              <div className='grid-header'>Caja</div>
            </Item>
            <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
              <Tooltip target='.filter-button' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                Filtrar preórdenes
              </Tooltip>
              <Button className='filter-button' icon={filter} text='Filtrar' stylingMode='text' onClick={handleModalShowFilter} />
            </Item>
            <Item location='after' locateInMenu='auto' showText='inMenu' widget='dxButton'>
              <Tooltip target='.refresh-button' showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                Refrescar datos
              </Tooltip>
              <Button className='refresh-button' icon={resButtonRefresh} text='Actualizar' stylingMode='text' onClick={handleUpdateData} />
            </Item>
            <Item name='searchPanel' locateInMenu='auto' />
          </Toolbar>
          <Column
            visible={Prm_Preordenes}
            dataField='POrd_Ord_Id'
            caption='PREORDEN'
            width={90}
            alignment='center'
            cellRender={({ data }: { data: any }) => {
              const CzId = data.Ord_POrd_Id;
              return (
                <div id={`ord${CzId}`}>
                  <img
                    src={CreateOrders}
                    alt='Preorden'
                    onClick={() => {
                      handleFindPreOrder(data.Ord_POrd_Id);
                    }}
                  />
                  <Tooltip target={`#ord${CzId}`} showEvent='mouseenter' hideEvent='mouseleave' position='top'>
                    Ver preorden
                  </Tooltip>
                </div>
              );
            }}
          />
          <Column dataField='Ord_Numero' caption='ORDEN' width={100} allowEditing={false} allowSorting={false} alignment='center' />
          <Column dataField='Paciente.Pc_Identificacion' caption='IDENTIFICACIÓN' allowEditing={false} allowSorting={false} alignment='center' width={140} />
          <Column
            dataField='Paciente'
            cellRender={handlePatientCellRender}
            calculateCellValue={(rowData) => {
              const { Pc_Nombre, Pc_Apellido1, Pc_Apellido2 } = rowData.Paciente;
              return `${Pc_Nombre} ${Pc_Apellido1} ${Pc_Apellido2}`;
            }}
            caption='PACIENTE'
            alignment='left'
          />
          <Column dataField='Ord_FechaCreacion' caption='FECHA' dataType='date' format='dd/MM/yyyy' allowEditing={false} allowSorting={false} alignment='center' width={110} />
          <Column
            dataField='Detalle'
            cellRender={handleDetailCellRender}
            calculateCellValue={(rowData) => {
              const Detalles = rowData.PreOrdenesDetalle.map((x) => x.Estudio.Es_Abreviatura);
              return Detalles.join(', ');
            }}
            caption='EXÁMENES'
            alignment='left'
          />
          <Column dataField='Usuario.Us_Usuario' caption='USUARIO' allowEditing={false} allowSorting={false} alignment='center' width={100} />
          <Column caption='TOTAL' alignment='center' cellRender={({ data }) => formatNumber(data.Ord_ValorTotal, { type: 'currency' })} width={110} />
          <Column caption='ABONO' alignment='center' cellRender={renderAbonoColumn} width={110} />
          <Column caption='RESTANTE' alignment='center' cellRender={renderRestanteColumn} width={110} />
          <Column dataField='Ord_Liquidado' caption='ESTADO' allowEditing={false} allowSorting={false} alignment='center' cellRender={renderEstadoLiquidacion} width={80} />
        </DataGrid>
      </div>

      {modalFiltersVisible && (
        <FormPopup title='Filtrar órdenes' visible={modalFiltersVisible} setVisible={handleModalShowFilter} onSave={handleUpdateData} loading={false} allowSave={false}>
          <Form formData={currentFilters} labelLocation='left' className='plain-styled-form' colCount={1}>
            <ItemF dataField='Fechas[0]' label={{ text: 'Fecha inicial' }} editorType='dxDateBox' editorOptions={{ type: 'date' }} />
            <ItemF dataField='Fechas[1]' label={{ text: 'Fecha final' }} editorType='dxDateBox' editorOptions={{ type: 'date' }} />
            <ItemF dataField='PacDocument' label={{ text: 'Documento del paciente' }} editorType='dxTextBox' />
            <ItemF dataField='Ordenes[0]' label={{ text: 'Orden inicial' }} editorType='dxTextBox' />
            <ItemF dataField='Ordenes[1]' label={{ text: 'Orden final' }} editorType='dxTextBox' />
            <ItemF
              dataField='Usuarios'
              label={{ text: 'Usuarios' }}
              editorType='dxTagBox'
              editorOptions={{
                placeholder: 'Seleccione uno o más usuarios',
                dataSource: usersList,
                searchEnabled: true,
                displayExpr: 'Us_Usuario',
                valueExpr: 'Us_Id',
              }}
            />
            <ItemF
              dataField='Servicios'
              label={{ text: 'Servicios' }}
              editorType='dxTagBox'
              editorOptions={{
                placeholder: 'Seleccione uno o más servicios',
                dataSource: lstServicios,
                searchEnabled: true,
                displayExpr: 'Se_Nombre',
                valueExpr: 'Se_Id',
              }}
            />

            <ItemF
              dataField='Contratos'
              label={{ text: 'Contratos' }}
              editorType='dxTagBox'
              editorOptions={{
                placeholder: 'Seleccione uno o más contratos',
                dataSource: lstContratos?.Data || [],
                searchEnabled: true,
                displayExpr: lstContratos?.CampoVisible || 'Cl_Nombre',
                valueExpr: lstContratos?.CampoId || 'Cl_Id',
              }}
            />

            <ItemF
              dataField='Estado'
              label={{ text: 'Estado de la orden' }}
              editorType='dxSelectBox'
              editorOptions={{
                items: [
                  { label: 'Todos', value: null },
                  { label: 'Liquidado', value: true },
                  { label: 'No liquidado', value: false },
                ],
                displayExpr: 'label',
                valueExpr: 'value',
                placeholder: 'Seleccione un estado',
                searchEnabled: false,
              }}
            />
          </Form>
        </FormPopup>
      )}

      {modalPreOrderVisible && currentIdPreOrder && <ModalCreatePreOrder visible={modalPreOrderVisible} idPreOrder={currentIdPreOrder} setVisible={handleClosePreOrder} />}

      {modalLiquidarVisible && (
        <Popup title='Liquidar orden' visible={modalLiquidarVisible} showCloseButton={true} onHiding={onCancelClickLiquidar} fullScreen={isXSmall} width={500} height='auto'>
          <div className='plain-styled-form'>
            <div className='amount-to-liquidate'>
              <div className={`amount-label ${selectedRow?.Ord_ValorTotal !== paymentItems.reduce((acc, item) => acc + (item.Rof_Valor || 0), 0) ? 'error' : 'succcess'}`}>
                Valor a liquidar: &nbsp; <strong>{formatNumber(selectedRow?.Ord_ValorTotal, { type: 'currency' })}</strong>
              </div>
              <div className={`amount-label ${selectedRow?.Ord_ValorTotal !== paymentItems.reduce((acc, item) => acc + (item.Rof_Valor || 0), 0) ? 'error' : 'succcess'}`}>
                Valor restante: &nbsp;
                <strong>{formatNumber(selectedRow?.Ord_ValorTotal - paymentItems.reduce((acc, item) => acc + (item.Rof_Valor || 0), 0), { type: 'currency' })}</strong>
              </div>
            </div>
            <div className='payment-items-list'>
              {paymentItems.map((item, index) => {
                // Para abonos existentes: medio de pago y valor editables si tiene permiso
                // Para nuevos abonos: ambos campos editables
                const isNuevo = !item.Rof_Id;
                const canEditMedioPago = isNuevo || Prm_FactCaja_U;
                const canEditValor = isNuevo || Prm_FactCaja_U; // Permitir editar valor si es nuevo o tiene permisos
                return (
                  <div key={index} className={`payment-item-card ${canEditMedioPago ? '' : 'locked'}`}>
                    <div className='payment-item-header'>{item.Rof_Id ? `Abono #${index + 1}: ${moment(item.Rof_Fecha).format('DD/MM/YYYY hh:mm a')}` : `Nuevo abono #${index + 1}`}</div>
                    <div className='payment-item-body'>
                      <div className='payment-item-field'>
                        <SelectBox dataSource={paymentMethods} displayExpr='Fp_Nombre' valueExpr='Fp_Id' value={item.Rof_Fp_Id} disabled={!canEditMedioPago} placeholder='Forma de pago' onValueChanged={(e) => canEditMedioPago && handlePaymentItemChange(index, 'Rof_Fp_Id', e.value)} />
                      </div>
                      <div className='payment-item-field'>
                        <NumberBox 
                          value={item.Rof_Valor || 0} 
                          format='currency' 
                          placeholder='Valor' 
                          disabled={!canEditValor} 
                          onValueChanged={(e) => canEditValor && handlePaymentItemChange(index, 'Rof_Valor', e.value)}
                          buttons={isNuevo && canEditValor ? [{
                            name: 'fillRemaining',
                            location: 'after',
                            options: {
                              icon: 'money',
                              type: 'default',
                              stylingMode: 'text',
                              hint: 'Llenar con valor restante',
                              onClick: () => {
                                const valorRestante = selectedRow?.Ord_ValorTotal - paymentItems.reduce((acc, item) => acc + (item.Rof_Valor || 0), 0);
                                if (valorRestante > 0) {
                                  handlePaymentItemChange(index, 'Rof_Valor', valorRestante);
                                }
                              }
                            }
                          }] : undefined}
                        />
                      </div>
                      <div className='payment-item-field payment-item-notes'>
                        <TextArea value={item.Rof_Nota || ''} placeholder='Notas (opcional)' disabled={!canEditMedioPago} height={60} onValueChanged={(e) => canEditMedioPago && handlePaymentItemChange(index, 'Rof_Nota', e.value)} />
                      </div>
                      {isNuevo && (
                        <div className='payment-item-delete'>
                          <Button
                            icon='trash'
                            type='danger'
                            stylingMode='text'
                            onClick={() => {
                              const updated = [...paymentItems];
                              updated.splice(index, 1);
                              setPaymentItems(updated);
                            }}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <ToolbarItem toolbar='bottom' location='after' disabled={loading} visible={true}>
            <div className={`form-popup-buttons-container`}>
              {selectedRow && selectedRow.Ord_ValorTotal !== paymentItems.reduce((acc, item) => acc + (item.Rof_Valor || 0), 0) && <Button text='Nueva forma de pago' icon='plus' type='normal' onClick={handleAddPaymentItem} />}
              <Button text={loading ? 'Guardando...' : 'Guardar cambios'} icon='check' type='default' onClick={handleConfirmLiquidar} />
            </div>
          </ToolbarItem>
        </Popup>
      )}

      {/* Modal de confirmación para valores en 0 */}
      <ModalConfirmation visible={modalConfirmZeroValues} message='Seguro que desea liquidar valores en 0' onConfirm={handleConfirmZeroValues} onCancel={handleCancelZeroValues} buttons='No/Yes' />
    </div>
  );
};

export default Index;

const handlePatientCellRender = (data: any) => {
  const { Pc_Nombre, Pc_Apellido1, Pc_Apellido2 } = data.data.Paciente;
  return (
    <div>
      {Pc_Nombre} {Pc_Apellido1} {Pc_Apellido2}
    </div>
  );
};

const renderAbonoColumn = ({ data }: any) => {
  const abonos = data.OrdenesFacturacionFormasPago || [];
  const suma = abonos.reduce((acc: number, cur: any) => acc + (cur.Rof_Valor || 0), 0);
  return <div>{formatNumber(suma, { type: 'currency' })}</div>;
};

const renderRestanteColumn = ({ data }: any) => {
  const total = data.Ord_ValorTotal || 0;
  const abonos = data.OrdenesFacturacionFormasPago || [];
  const suma = abonos.reduce((acc: number, cur: any) => acc + (cur.Rof_Valor || 0), 0);
  const restante = total - suma;
  return <div>{formatNumber(restante, { type: 'currency' })}</div>;
};

const handleDetailCellRender = (data: any) => {
  const Detalles: string[] = data.data.PreOrdenesDetalle.map((x: any) => {
    return x.Estudio.Es_Abreviatura;
  });

  return <div>{Detalles.join(', ')}</div>;
};
